module.exports = __webpack_public_path__ + "static/media/AshevilleHempFarms3newstorefront1downtownAsheville2020Watergildedandhandlettered.bd0be4ca.webp";